// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3371":"961e35a0f57a74a3bf23","8698":"961e35a0f57a74a3bf23"}[chunkId] + ".chunk.css";
};